import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const QuestionMarkIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.20117 2.95821C9.65957 2.12612 11.3708 1.82297 13.0332 2.09981C14.696 2.37675 16.2103 3.21747 17.3047 4.4797C18.3993 5.74231 19.0023 7.34516 19 9.00509L18.9941 9.24044C18.8786 11.6571 17.0025 13.34 15.4561 14.341C14.6241 14.8796 13.7992 15.2788 13.1865 15.5432C12.8789 15.6759 12.6207 15.7762 12.4375 15.844C12.3458 15.8779 12.2724 15.9042 12.2207 15.9221L12.1416 15.9484C12.1396 15.9491 12.1367 15.9504 12.1367 15.9504L12.1348 15.9514H12.1328C11.6074 16.1214 11.0441 15.8332 10.874 15.3078C10.7041 14.7824 10.9922 14.2191 11.5176 14.049C11.5176 14.049 11.5223 14.0475 11.5264 14.0461C11.535 14.0432 11.5493 14.038 11.5684 14.0315C11.6071 14.0181 11.6664 13.9974 11.7432 13.969C11.8977 13.9118 12.1225 13.8242 12.3936 13.7072C12.9386 13.472 13.6577 13.1228 14.3691 12.6623C15.8602 11.6972 16.9998 10.4586 17 9.00509V9.00313C17.0018 7.83172 16.5773 6.69274 15.7939 5.78927C15.0101 4.88518 13.9167 4.27432 12.7051 4.07247C11.4932 3.87065 10.2483 4.09309 9.19238 4.69552C8.13703 5.29773 7.34184 6.23895 6.94043 7.34688C6.7523 7.86614 6.17843 8.13462 5.65918 7.94649C5.14 7.75832 4.87145 7.18446 5.05957 6.66524C5.62602 5.10192 6.74213 3.79079 8.20117 2.95821Z"
        fill="currentColor"
      />
      <path
        d="M13.5 20.5002C13.5 21.3286 12.8284 22.0002 12 22.0002C11.1716 22.0002 10.5 21.3286 10.5 20.5002C10.5 19.6718 11.1716 19.0002 12 19.0002C12.8284 19.0002 13.5 19.6718 13.5 20.5002Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default QuestionMarkIcon;
